export const GAMES_GRID = [
  { id: "plinko", title: "Plinko", path: "/games/plinko", image: "/games/plinko.svg" },
  { id: "lucky-scratch", title: "Lucky Scratch", path: "/games/lucky-scratch", image: "/games/lucky-scratch.svg" },
  { id: "avia", title: "Avia", path: "/games/avia", image: "/games/avia.svg" },
  { id: "magic-cup", title: "Magic Cup", path: "/games/magic-cup", image: "/games/magic-cup.svg" },
  { id: "knife-hit", title: "Knife Hit", path: "/games/knife-hit", image: "/games/knife-hit.svg" },
  { id: "crossy-bird", title: "Crossy Bird", path: "/games/crossy-bird", image: "/games/crossy-bird.svg" },
  { id: "wheel", title: "Wheel", path: "/games/wheel", image: "/games/wheel.svg" },
  { id: "ninja", title: "Ninja", path: "/games/ninja", image: "/games/ninja.svg" },
];

export const getGameById = (id) => GAMES_GRID.find((game) => game.id === id);
